export const isTruthyIncludingZero = (value: any): boolean => {
  return !!value || value === 0;
};
